module.exports = __webpack_public_path__ + "img/u3a.35e8f273.jpg";